import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import copyEntityIcon from 'v2/icons/copyEntityIcon.svg';
import styles from './copyEntityButton.module.scss';

const CopyEntityButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  const entityURL = window.location.href;

  const handleTooltipToggle = () => {
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 500);
  };

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(entityURL);
  };

  return (
    <OverlayTrigger
      placement="top"
      trigger="click"
      show={showTooltip}
      onToggle={handleTooltipToggle}
      overlay={
        <Tooltip id={'copyButtonTooltip'} className={styles.copyButtonTooltip}>
          Copied to Clipboard!
        </Tooltip>
      }
    >
      <button className={styles.copyButton} onClick={handleCopyClick}>
        <img
          src={copyEntityIcon}
          alt="Copy entity icon"
          className={styles.copyEntityIcon}
        />
      </button>
    </OverlayTrigger>
  );
};

export default CopyEntityButton;
